import React from 'react';

import ArticleCard from '../ArticleCard';

interface CoachArticlesProps {
  articles: Possible<CMSArticle[]>;
}

const CoachArticles: React.FC<CoachArticlesProps> = ({ articles }) => {
  return (
    <>
      <h2 className="mb-8 text-left text-2xl font-medium text-leland-gray-dark">
        Articles
      </h2>
      <div className="flex space-x-8 overflow-x-auto">
        {articles?.map((article) => (
          <ArticleCard key={article._id} large article={article} />
        ))}
      </div>
    </>
  );
};

export default CoachArticles;
